import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { isBacktrackEnabled } from 'src/modules/backtrack/env';

if (isBacktrackEnabled()) {
  import('src/modules/backtrack')
    .then(({ initBacktrack }) => initBacktrack())
    .catch(() => {});
}

/**
 * CRA error overlay trata este aviso benigno do browser como runtime error.
 * Já ignorado no Sentry; aqui evitamos a tela vermelha em dev.
 */
const isBenignResizeObserverError = message =>
	typeof message === 'string' &&
	/ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i.test(
		message
	);

window.addEventListener(
	'error',
	event => {
		if (isBenignResizeObserverError(event.message)) {
			event.stopImmediatePropagation();
		}
	},
	true
);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
